import { FC } from 'react';
import { AnalyticsLineChart } from 'shared/ui/Analytics/AnalyticsLineChart';
import { LineChartData } from 'shared/ui/Analytics/types';
import { Col } from 'shared/ui/Col';
import { Row } from 'shared/ui/Row';
import { SmallChip } from 'shared/ui/SmallChip';
import { getRenamedLineChartData } from '../../../lib/getRenamedLineChartData';

interface ObjectViewsChartProps {
  pointsData: LineChartData[];
  minWidth: number;
}

const chartLines = [
  { key: 'line1', label: 'Все просмотры', color: '#1E90FF' },
  { key: 'line2', label: 'Уникальные пользователи', color: '#8419AA' },
];

export const ObjectViewsChart: FC<ObjectViewsChartProps> = ({
  pointsData,
  minWidth,
}) => {
  const renamedPointsData = getRenamedLineChartData(pointsData, chartLines);

  return (
    <Col sx={{ height: '100%' }}>
      <AnalyticsLineChart
        data={renamedPointsData}
        lineLabels={chartLines.map((l) => l.label)}
        lineColors={chartLines.map((l) => l.color)}
        minWidth={minWidth}
        height={200}
      />

      <Row spacing={8} sx={{ alignItems: 'center' }}>
        <Row spacing={4}>
          {chartLines.map(({ label, color }) => (
            <SmallChip key={label} label={label} color={color} />
          ))}
        </Row>
      </Row>
    </Col>
  );
};
